import Wrapper from "./Wrapper";
import Properties from "./Properties";
import Activity from "./Activity";
import New from "./New";

export default { Wrapper, Properties, Activity, New };
